import { useMany, useOne } from '@refinedev/core';
import type { BannerActionDetailOut, BannerOut } from '@/api/generated/schemas';
import { buildPreviewModel } from './bannerPreview';

/** A banner plus its creatives, assembled into what the preview renders.
 * `isLoading` separates "no creatives" from "not fetched yet". */
export const useBannerPreviewModel = (bannerId: number, enabled = true) => {
  const { result: banner, query: bannerQuery } = useOne<BannerOut>({
    resource: 'user_catalog.banners',
    id: bannerId,
    queryOptions: { enabled },
  });

  const actionIds =
    banner?.banner_links?.map((link) => link.banner_action_id) ?? [];
  const { result: actions, query: actionsQuery } =
    useMany<BannerActionDetailOut>({
      resource: 'user_catalog.banner_actions',
      ids: actionIds,
      queryOptions: { enabled: enabled && actionIds.length > 0 },
    });

  const actionsById = new Map(
    (actions?.data ?? []).map((action) => [action.id, action])
  );

  return {
    model: buildPreviewModel(banner?.banner_links, actionsById),
    isLoading:
      !enabled ||
      bannerQuery.isLoading ||
      (actionIds.length > 0 && actionsQuery.isLoading),
  };
};
